var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterSecond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "11053981_x_logo_twitter_new_brand_icon 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.7688 9.19359L8.6842 1.9523L8.65433 1.90977H8.60236H2.65234H2.45992L2.57051 2.06724L10.3263 13.1112L2.57725 21.9242L2.43126 22.0902H2.65234H4.41491H4.46015L4.49002 22.0563L11.2261 14.3931L16.601 22.0477L16.6308 22.0902H16.6828H22.6328H22.8252L22.7147 21.9328L14.6728 10.478L22.0598 2.07579L22.2057 1.90977H21.9847H20.2221H20.1769L20.147 1.94371L13.7688 9.19359ZM12.2122 13.1575L12.2122 13.1574L11.4206 12.0506L11.4206 12.0506L5.24492 3.40996H7.70675L12.7534 10.4715L12.7535 10.4717L13.5417 11.5784L13.5418 11.5785L20.0269 20.6534H17.5651L12.2122 13.1575Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterSecond);
export default __webpack_public_path__ + "static/media/twitter_second.88b99aabbcc1a4c609d2e82608dbfbe1.svg";
export { ForwardRef as ReactComponent };